type BoxVariant = 'ods-gp' | 'brand';

interface BoxVariantStyles {
    border: string;
    rounded: string;
    imgSize: string;
    width: string;
}

const boxVariantStyles: Record<BoxVariant, BoxVariantStyles> = {
    'ods-gp': {
        border: '',
        rounded: 'rounded-sm',
        imgSize: 'w-[4.625rem] h-[4.625rem]',
        width: ''
    },
    brand: {
        border: '',
        rounded: 'rounded-sm',
        imgSize: 'w-full h-full md:w-[7.75rem] md:h-[7.75rem]',
        width: 'w-[9.3125rem] md:min-w-[10.1125rem] lg:min-w-[10.4rem] xl:w-[13.5rem]'
    },
};

const BoxImg = ({
    icono,
    alt,
    color,
    classImg,
    className,
    variant = 'ods-gp',
}: {
    icono: string;
    alt: string;
    color?: string;
    classImg?: string;
    className?: string;
    variant?: BoxVariant;
}) => {
    const styles = boxVariantStyles[variant];
    const bgStyle = color ? { backgroundColor: color } : undefined;
    const fallbackClass = !color ? 'bg-primary-100' : '';

    return (
        <div
            className={`${styles.border} ${styles.rounded} ${styles.width} h-full flex justify-center overflow-hidden ${fallbackClass} ${className || ''}`}
            style={bgStyle}
        >
            <div className="p-2 flex items-center h-full">
                <img
                    src={icono}
                    alt={alt}
                    className={`${styles.imgSize} object-contain ${classImg}`}
                />
            </div>
        </div>
    );
};

export default BoxImg;